import { render, staticRenderFns } from "./PageComponent.vue?vue&type=template&id=5d22b928&scoped=true&"
import script from "./PageComponent.vue?vue&type=script&lang=js&"
export * from "./PageComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageComponent.vue?vue&type=style&index=0&id=5d22b928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22b928",
  null
  
)

export default component.exports